"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockUseTheme = void 0;
var _object = require("../type-checks/object");
const merge = require("deepmerge"),
  /**
   * Method to return mock theme object for testing
   *
   * @name mockUseTheme
   * @param {object} obj Optional object to pass custom theme values
   * @returns {object} Composite Theme Object
   */
  mockUseTheme = obj => {
    const defaultObject = {
        identifier: "mockGeneralTheme",
        breakpoints: {
          unit: "px",
          values: {
            md: "660",
            lg: "1200"
          }
        },
        minWidth: "1200px",
        contentSpacing: {
          mobileHeader: "45px",
          desktopHeader: "75px",
          mobileInterior: "30px",
          desktopInterior: "50px",
          mobileFooter: "45px",
          desktopFooter: "75px"
        },
        bannerHeaderHeights: {
          landing: "40rem",
          subLanding: "26rem"
        },
        fontFamilies: {
          bold: "Helvetica",
          default: "Helvetica",
          italic: "Helvetica",
          semiBold: "Helvetica"
        },
        headings: {
          InteriorPageHeading: {
            display: "block"
          },
          InteriorPageSubHeading: {
            display: "block"
          },
          CardHeading: {
            display: "block"
          },
          RTEHeading: {
            display: "block"
          },
          RTESubHeading: {
            display: "block"
          }
        },
        palette: {
          primary: {
            main: "#000000"
          },
          secondary: {
            main: "#EAEAEB"
          },
          text: {
            primary: "#EAEAEB"
          },
          background: {
            ad: "#EAEAEB"
          },
          footer: {
            border: "black",
            separator: "black"
          }
        },
        mixins: {
          container: {
            inner: {
              margin: "2rem",
              width: "1200px"
            },
            outer: {
              margin: "2rem",
              padding: "2rem",
              width: "100%"
            }
          },
          focus: {
            fontFamily: "Helvetica"
          },
          headings: {
            InteriorPageHeading: {
              base: {
                display: "block"
              },
              caption: {
                display: "block"
              },
              content: {
                display: "block"
              }
            },
            InteriorPageSubHeading: {
              base: {
                display: "block"
              },
              caption: {
                display: "block"
              },
              content: {
                display: "block"
              }
            },
            CardHeading: {
              base: {
                display: "block"
              },
              caption: {
                display: "block"
              },
              content: {
                display: "block"
              }
            },
            RTEHeading: {
              base: {
                display: "block"
              },
              caption: {
                display: "block"
              },
              content: {
                display: "block"
              }
            },
            RTESubHeading: {
              base: {
                display: "block"
              },
              caption: {
                display: "block"
              },
              content: {
                display: "block"
              }
            }
          },
          hiddenVisually: {
            left: "-9999px !important",
            overflow: "hidden !important",
            position: "absolute !important",
            top: "-9999px !important"
          },
          hiddenVisuallyUndo: {
            left: "0 !important",
            overflow: "visible",
            top: "0 !important"
          },
          navigation: {
            desktop: {
              primaryLinkColor: "#000000",
              primaryLinkColorHover: "#000000",
              primaryBorderColor: "#000000",
              primaryBorderColorHover: "#000000",
              secondaryLinkColor: "#000000",
              secondaryLinkColorHover: "#000000",
              signInLinkColor: "#000000",
              signInLinkColorHover: "#000000",
              signInLinkBackgroundColor: "#FFFFFF",
              signInLinkBackgroundColorHover: "#FFFFFF",
              signInButtonColor: "#000000",
              signInButtonColorHover: "#000000",
              signInButtonBackgroundColor: "#FFFFFF",
              signInButtonBackgroundColorHover: "#FFFFFF"
            },
            mobile: {
              linkColor: "#000000",
              linkBackgroundColorHover: "#FFFFFF",
              linkColorHover: "#000000",
              backButtonColor: "#CCCCCC",
              backButtonColorHover: "#CCCCCC",
              backButtonBackgroundColor: "#CCCCCC",
              backButtonBackgroundColorHover: "#CCCCCC",
              signInLinkColor: "#000000",
              signInLinkColorHover: "#000000",
              signInLinkBackgroundColor: "#FFFFFF",
              signInLinkBackgroundColorHover: "#FFFFFF",
              headingUnderline: "#000000",
              drawerPaperBackgroundColor: "#343434",
              drawerPaperColor: "white",
              drawerModalBackgroundColor: "transparent",
              drawerButtonBackgroundColorHover: "transparent",
              dividerColor: "#CCCCCC",
              closeIconColor: "#000000",
              buttonIconColor: "red",
              logoBackgroundColor: "white",
              indicatorBackgroundColor: "black",
              indicatorColor: "white"
            }
          },
          overlay: {
            iconCard: "#FFFFFF"
          },
          variantButtons: {
            primary: {
              display: "inline-block"
            },
            secondary: {
              display: "inline-block"
            },
            outline: {
              display: "inline-block"
            },
            tertiary: {
              display: "inline-block"
            },
            ctalink: {
              display: "inline-block"
            },
            ctalinkWithArrow: {
              display: "inline-block"
            }
          }
        },
        shape: {
          borderRadius: "5px"
        },
        breadcrumb: {
          backgroundColor: "#000000",
          color: "#FFFFFF",
          colorHover: "#CCCCCC",
          fontFamily: {
            default: "Helvetica",
            last: "Helvetica"
          },
          fontSize: "18px"
        },
        calculator: {
          linearProgress: {
            backgroundColor: "gray",
            color: "red",
            subheadingColor: "blue"
          }
        },
        quiz: {
          linearProgress: {
            backgroundColor: "gray",
            color: "red",
            subheadingColor: "blue"
          },
          modal: {
            backgroundColor: "white",
            borderColor: "black",
            closeButtonColor: "gray"
          },
          namePanel: {
            headingColor: "black"
          },
          results: {
            score: {
              backgroundColor: "white"
            },
            title: {
              backgroundColor: "white",
              borderColor: "gray",
              printIcon: {
                color: "blue"
              },
              printText: {
                background: "blue",
                color: "black",
                fontFamily: "Helvetica"
              },
              user: {
                borderRight: {
                  color: "green"
                },
                icon: {
                  backgroundColor: "gray",
                  color: "black"
                },
                text: {
                  fontFamily: "Helvetica"
                }
              }
            }
          }
        },
        search: {
          inputBorderColor: "#000000",
          inputPlaceholderColor: "#CCCCCC",
          closeButtonColor: "#CC0000",
          backgroundGradients: "linear-gradient(to right, #000000, #FFFFFF)"
        },
        skipLinks: {
          backgroundColor: "#FFFFFF",
          borderRadius: "0.2rem solid #FF00FF",
          fontFamily: "Helvetica",
          fontSize: "1.4rem"
        },
        tabs: {
          desktop: {
            list: {
              borderBottomColor: "red",
              borderRadius: "5px",
              borderBottomStyle: "solid",
              borderBottomWidth: "1px",
              paddingBottom: "10px",
              paddingLeft: "10px",
              paddingRight: "10px",
              paddingTop: "10px"
            },
            indicator: {
              display: "none"
            },
            panel: {
              paddingBottom: "10px",
              paddingLeft: "10px",
              paddingRight: "10px",
              paddingTop: "10px",
              firstHeading: {
                color: "black",
                fontFamily: "Helvetica",
                fontSize: "16px"
              }
            },
            scrollButtons: {
              width: "10px"
            },
            tab: {
              backgroundColor: "gray",
              borderBottomLeftRadius: "0",
              borderBottomRightRadius: "0",
              borderColor: "red",
              borderStyle: "solid",
              borderTopLeftRadius: "5px",
              borderTopRightRadius: "5px",
              borderWidth: "1px",
              color: "black",
              fontFamily: "Helvetica",
              fontSize: "16px",
              marginBottom: "0",
              marginLeft: "0",
              marginLeftSubsequent: "20px",
              marginRight: "0",
              marginTop: "0",
              paddingBottom: "10px",
              paddingLeft: "10px",
              paddingRight: "10px",
              paddingTop: "10px",
              textTransform: "uppercase",
              selected: {
                backgroundColor: "grey",
                borderBottomColor: "blue",
                borderBottomStyle: "solid",
                borderBottomWidth: "0",
                borderRadius: "0",
                fontFamily: "Helvetica",
                textTransform: "uppercase",
                after: {
                  backgroundColor: "blue",
                  bottom: "0",
                  left: "0",
                  height: "5px",
                  width: "85px"
                }
              }
            }
          },
          tablet: {
            list: {
              paddingLeft: "10px",
              paddingRight: "10px"
            },
            scrollButtons: {
              width: "10px"
            },
            tab: {
              marginLeftSubsequent: "10px"
            },
            panel: {
              paddingBottom: "10px",
              paddingLeft: "10px",
              paddingRight: "10px",
              paddingTop: "10px"
            }
          },
          mobile: {
            list: {
              paddingLeft: "10px",
              paddingRight: "10px"
            },
            scrollButtons: {
              width: "10px"
            },
            tab: {
              marginLeftSubsequent: "10px"
            },
            panel: {
              paddingBottom: "10px",
              paddingLeft: "10px",
              paddingRight: "10px",
              paddingTop: "10px"
            }
          }
        },
        transitions: {
          duration: {
            shortest: 150,
            shorter: 200,
            short: 250,
            standard: 300,
            complex: 375,
            enteringScreen: 225,
            leavingScreen: 195
          }
        },
        typography: {
          fontFamily: "Helvetica",
          fontSize: 16,
          htmlFontSize: 10,
          body1: {
            lineHeight: 5
          }
        }
      },
      customObject = (0, _object.isObject)(obj) ? obj : {},
      composite = merge(defaultObject, customObject);
    return composite;
  };
exports.mockUseTheme = mockUseTheme;